import React from "react";

const ProductRecommendationList = ({ recommendations, navigate }) => {
  return (
    <section className="pdp-recommend-card">
      <h3 className="pdp-recommend-title">Sản phẩm gợi ý</h3>

      <div className="pdp-recommend-list">
        {recommendations?.length > 0 &&
          recommendations?.map((rec) => (
            <article
              key={rec?.product_name}
              onClick={() => navigate(`/product/${rec?.product_slug}`)}
              className="pdp-recommend-item"
            >
              <img
                src={rec?.product_img || null}
                className="pdp-recommend-image"
                alt="Recommend Product"
              />

              <div className="pdp-recommend-content">
                <p className="pdp-recommend-name">{rec?.product_name || "Product"}</p>
                <p className="pdp-recommend-price">
                  {(
                    rec?.product_price?.toLocaleString() ||
                    Math.min(...(rec?.packages || []).map((p) => p.price))?.toLocaleString() ||
                    0
                  )}
                  đ
                </p>
                <p className="pdp-recommend-sold">Đã bán {rec?.product_sold_amount || 0}</p>
              </div>
            </article>
          ))}
      </div>
    </section>
  );
};

export default ProductRecommendationList;
